import { render, staticRenderFns } from "./PayslipList.vue?vue&type=template&id=98d6b37e&scoped=true"
import script from "./PayslipList.vue?vue&type=script&lang=js"
export * from "./PayslipList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d6b37e",
  null
  
)

export default component.exports